import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import { useCookies } from 'react-cookie';
import ReactGA from 'react-ga';
import { LinearProgress } from '@material-ui/core';
ReactGA.initialize('UA-138580990-1');

export default function Popup(props) {
  const [cookies, setCookie] = useCookies(['dlref']);
  const [loading, setLoading] = useState(false);
  // const [cookies, setCookie] = useCookies(['dluser']);
  const userID = props.userID;
  let userOrders = props.userOrders;
  if (typeof userOrders !== 'undefined') {
    userOrders = userOrders.toString();
    if (userOrders.charAt(0) === ",") {
      userOrders = userOrders.substring(1);
    }
  }

  // const uid = props.uid.toLowerCase().replace("cbx", "");
  const [pin, setPin] = useState("");
  const [showSnack, setShowSnack] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  // console.log("userID", userID);
  // console.log("userOrders", userOrders);

  useEffect(() => {
    const coords = (pos) => {
      setLongitude(pos.coords.longitude);
      setLatitude(pos.coords.latitude);
    }
    //   navigator.geolocation.getCurrentPosition(coords);
  });

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnack(false);
  };



  const verifyAccount = async () => {
    setLoading(true)

    if (pin.length != 4 || !Number.isInteger(parseInt(pin))) {
      setSnackMsg("Four(4) digit pin please.");
      setShowSnack(true);
      setLoading(false)
      return false;
    }

    fetch('https://www.mydigicellive.com/auth2-dl/auth.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, // this line is important, if this content-type is not set it wont work
      body: `pin=${pin}&ref=${cookies.dlref}&ava=${props.data.picture}&nickname=${props.data.nickname}&email=${props.data.email}`
    }).then(res => res.json())
      .then(json => {
        // console.log(json, "dataaa");
        ReactGA.ga('send', 'event', 'Authentication', 'successful-login', 'Successful Login');
        setSnackMsg(json.msg);
        setShowSnack(true);
        setPin('')
        if (json.data == true) {
          setCookie('dluser', json.token, { path: '/', domain: '.mydigicellive.com', maxAge: (3600 * 24 * 365), sameSite: true, secure: true  });
          props.closePopup();
          //redirect to goto
          setLoading(false)
          if (typeof (cookies.goto) == 'undefined' || cookies.goto == 'undefined') {
            window.location.href = 'https://mydigicellive.com/zero/home.php?welcome'
          } else {
            window.location.href = cookies.goto;
          }

        }
        setLoading(false)
        //   setCookie('dlref', json.data, { path: '/' });
      })
      .catch((err) => {
        console.error(err);
        setLoading(false)
        setSnackMsg("Something went wrong. Please tray again.");
        setShowSnack(true);
        setPin('')
        props.closePopup();
        //snackbar retry please
      })

  }
  // function handleSubmit(event) {
  //     event.preventDefault();
  //     // console.log(props.orders);
  //     verifyAccount();

  // }

  return (
    <div>
      <form>
        <Dialog open={props.show} onClose={props.listClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Verify Account</DialogTitle>
          <LinearProgress color="secondary" hidden={!loading} />
          <DialogContent>
            <DialogContentText>
              Enter pin that was sent to your phone
            </DialogContentText>

            <TextField
              required
              autoFocus
              margin="dense"
              id="pin"
              label="PIN"
              type="number"
              length="4"
              autoComplete="off"
              // pattern="^-?[0-9]\d*\.?\d*$"
              pattern="[0-9]*"
              inputProps={{
                maxLength: 4,
                minLength: 4,
              }}
              value={pin}
              onChange={e => setPin(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={props.closePopup} color="primary">
              Close
            </Button>
            <Button
              type="submit"
              variant='contained'
              disabled={loading}
              onClick={verifyAccount} color="primary">
              Verify
            </Button>
          </DialogActions>
        </Dialog>
      </form>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={showSnack}
        autoHideDuration={4000}
        onClose={handleCloseSnackBar}
        message={snackMsg}
      />
    </div>
  );
}
